// 启动引导 / Auth bootstrap.
// 向后端查询 /auth/status；匿名合法，不做任何重定向。
// Stage E: no more SSO redirects; anonymous visitors stay on the main page.

import { authApi as defaultAuthApi, type AuthStatus } from "@/api/auth";
import { renderHeaderAuth } from "@/features/header-auth";
import {
  readCachedAuthStatus,
  writeCachedAuthStatus,
} from "@/features/auth-session-cache";
import { state } from "@/state/store";

// 注入依赖：测试里传 mock authApi 与 redirect / Injected deps for tests.
interface Deps {
  authApi: Pick<typeof defaultAuthApi, "status">;
  redirect: (url: string) => void;
}

const DEFAULT_DEPS: Deps = {
  authApi: defaultAuthApi,
  redirect: (url) => {
    window.location.href = url;
  },
};

/**
 * 启动引导：先用本地快照即时渲染，再用 /auth/status 后台校正。
 * Bootstrap entrypoint: render immediately from local snapshot, then reconcile
 * with /auth/status in the background.
 */
export async function bootstrap(deps: Partial<Deps> = {}): Promise<AuthStatus> {
  const d: Deps = { ...DEFAULT_DEPS, ...deps };
  const cached = readCachedAuthStatus();
  if (cached) {
    state.auth = cached;
  }
  renderHeaderAuth();

  const status = await d.authApi.status();
  state.auth = status;
  writeCachedAuthStatus(status);
  renderHeaderAuth();
  return status;
}
